import type {BioIconProps} from '../../icons/common-types'

export default function HomeEssentialsInsiderLogo({...attributes}: BioIconProps) {
  return (
    <div className="domain_logo flex w-fit items-center gap-2 text-2xl font-semibold tablet:gap-1 tablet:text-base">
      <svg width="33" height="33" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg" {...attributes}>
        <path
          opacity="0.4"
          d="M25.135 20.4151H8.57497C6.36163 20.4151 5.0283 18.6685 5.61497 16.5351L8.5483 5.76178C8.88163 4.52178 10.2283 3.49512 11.5083 3.49512H22.2016C23.4816 3.49512 24.8283 4.52178 25.1616 5.76178L28.095 16.5351C28.6816 18.6685 27.3483 20.4151 25.135 20.4151Z"
          fill="#0D2818"
        />
        <path
          d="M23.1823 29.1617C23.1823 29.7084 22.729 30.1617 22.1823 30.1617H11.5156C10.969 30.1617 10.5156 29.7084 10.5156 29.1617C10.5156 28.615 10.969 28.1617 11.5156 28.1617H15.849V20.415H17.849V28.1617H22.1823C22.729 28.1617 23.1823 28.615 23.1823 29.1617Z"
          fill="#0D2818"
        />
      </svg>
      <span>Home Essentials Insider</span>
    </div>
  )
}
